import { Component } from '@angular/core';
import { FooterComponent } from '../footer.component';

@Component({
  selector: 'app-footer-four',
  templateUrl: './footer-four.component.html',
  styleUrls: ['./footer-four.component.scss']
})
export class FooterFourComponent extends FooterComponent {


}
